export default __webpack_public_path__ + "static/media/greenTick.17671bd7.svg";